import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../query"
import api from "../client"
import { AuthIsAuthenticatedResponseData } from "../types/auth"

const getData = async () => {
  const { data } = await api.get(`/is-authenticated`)
  return data
}

export const useAuthIsAuthenticated = (): QueryObserverBaseResult<AuthIsAuthenticatedResponseData> => {
  const { data, ...props } = useQuery<AuthIsAuthenticatedResponseData>(
    queryKeys.ISAUTH,
    () => getData(),
  )
  return { data, ...props }
}
